module.exports = __webpack_public_path__ + "img/medium.ff9eab1a.svg";